<script lang="ts">
  import { authState, signOut } from '../lib/auth';
  import { go, route } from '../lib/stores';
  import { hasCloud } from '../lib/db';
  import Wordmark from './Wordmark.svelte';
</script>

<nav class="nav">
  <button class="brand ghost" on:click={() => go('/')} aria-label="Home">
    <Wordmark size={28} />
  </button>
  <span class="tagline dim">ancestry.treeview</span>
  <div class="spacer" />
  {#if !hasCloud}
    <span class="chip gold" title="Preview build — your data lives in this browser only. Cloud sync isn't wired in for the demo.">preview · local</span>
  {/if}
  {#if $authState.status !== 'anonymous'}
    <span class="chip">{$authState.email}</span>
    {#if $authState.status === 'admin'}
      <button class="ghost small" on:click={() => go('/admin')} class:active={$route.name === 'admin'}>admin</button>
    {/if}
    <button class="ghost small" on:click={signOut}>sign out</button>
  {/if}
</nav>

<style>
  .nav {
    display: flex; align-items: center; gap: 10px;
    padding: 0 20px;
    height: var(--ls-nav-h);
    background: color-mix(in srgb, var(--ls-surface) 70%, transparent);
    backdrop-filter: saturate(1.1) blur(12px);
    -webkit-backdrop-filter: saturate(1.1) blur(12px);
    border-bottom: 1px solid var(--ls-border);
    position: sticky; top: 0; z-index: 20;
  }
  .brand { padding: 4px 6px; }
  .tagline {
    font-family: var(--ls-font-mono);
    font-size: 11px;
    padding-left: 8px;
    border-left: 1px solid var(--ls-border);
    margin-left: 2px;
  }
  .spacer { flex: 1; }
  .active { background: var(--ls-surface-2); }
  @media (max-width: 640px) { .tagline { display: none; } .chip:not(.gold) { display: none; } }
</style>
